<template>
    <form v-on:submit.prevent="createProject()" class="modal-card" style="min-width: 30em; width: auto" >
        <!-- <header class="modal-card-head">
            <p class="modal-card-title">
                Create New Project
            </p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
        </header> -->
        <!-- <header class="modal-card-head">
            <p class="modal-card-title">Login</p>
        </header> -->
        
        <section class="modal-card-body" style="height: auto">
            
            <button
            type="button"
            class="delete"
            @click="$emit('close')"/>
        
            <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
            </b-loading>
            
            <b-steps	
            :animateInitially="true"
            v-model="setupStep"
            :has-navigation="false">
        

                <b-step-item step="0" :label="modelType">
                    <!-- <h1 class="title has-text-centered">Select a model output</h1> -->
                    <h2 class="subtitle is-4 has-text-centered">
                        <small>
                            <p class="subtitle is-7 is-uppercase">NEW MODEL</p>
                            Choose a Model Type
                        </small>
                    </h2>

                    <div class="columns is-centered">
                        <div class="column is-8 is-desktop ">
                            <div class="columns is-centered">
                                <div class="column is-full">
                                    <div class="setup-grid setup-center">
                                        <div  v-for="i in modelTypeList">
                                            <span class="has-text-centered">{{ i.name }}</span>
                                            <br>
                                            <a @click="modelType = i.id">
                                            <b-image :class="'card setup '+(modelType == i.id?'setup-selected':'')" :src="require(`@/images/ai-task-${i.id}.svg`)" 
                                                    style="max-height: 15em; min-width: 10em;">
                                            </b-image>
                                            </a>
                                        </div>
                                    </div>
                                    <br><br>
                                    <p class="subtitle has-text-centered" v-if="modelType == 'classification'">
                                        I want to build a text classifier model that can <b>classify</b> text into <b>categories</b> like <b>topics</b>, <b>intents</b> or <b>sentiments</b> based on example <b>dataset</b> that I'll provide.
                                    </p>
                                    <p class="subtitle has-text-centered" v-if="modelType == 'answering'">
                                        I want to build a question answering model that can <b>search</b> and <b>answer</b> questions like <b>who won the last FIFA world cup?</b> based on a <b>knowledge base</b> that I'll provide.
                                    </p>
                                    <p class="subtitle has-text-centered" v-if="modelType == 'generation'">
                                        I want to build a text generation model that can <b>generate</b> text like <b>product descriptions</b> based on example <b>dataset</b> that I'll provide.
                                    </p>
                                    <p class="subtitle has-text-centered" v-if="modelType == 'extraction'">
                                        I want to build a text extractor model that can <b>extract</b> information like <b>dates</b>, <b>locations</b> or <b>names</b> from text based on example <b>dataset</b> that I'll provide.
                                    </p>
                                    <p class="subtitle has-text-centered" v-if="modelType == 'summarization'">
                                        I want to build a text summarizer model that can <b>summarize</b> text like <b>news articles</b> based on example <b>dataset</b> that I'll provide.
                                    </p>
                                    <footer class="model-card-foot buttons">
                                        <b-button expanded tag="router-link" class="is-ghost" size="is-medium" :to="`/explore`">Or Explore our Model Hub Examples</b-button>
                                    </footer>
                                </div>
                        </div>
                        </div>
                        
                    </div>
                    
                </b-step-item>

                <b-step-item step="1" :label="setupStep>=1?inputTask:''">
                    <h2 class="subtitle is-4 has-text-centered">
                        <small>
                            <p class="subtitle is-7 is-uppercase">IMPORT DATA</p>
                            Choose a Data Source
                        </small>
                    </h2>

                    <div class="columns is-centered">
                        <div class="column is-8">
                            <div class="columns is-centered">
                                <div class="column is-full">
                                    <div class="setup-grid setup-center">
                                        <div  v-for="i in inputTaskList">
                                            <span class="has-text-centered">{{ i.name }}</span>
                                            <br>
                                            <a @click="inputTask = i.id">
                                            <b-image :class="'card setup '+(inputTask == i.id?'setup-selected':'')" 
                                                    :src="require(`@/images/ai-input-${i.id}.svg`)"
                                                    style="max-height: 15em; min-width: 10em;">
                                            </b-image>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        </div>
                        
                    </div>
                </b-step-item>

                <b-step-item step="2" :label="importDataCompleted && setupStep>2?'uploaded':(setupStep==2?'in progress':'')">
                    <h2 class="subtitle is-4 has-text-centered">
                        <small v-if="inputTask == 'library'">
                            <p class="subtitle is-7 is-uppercase">Select data from library</p>
                        </small>
                        <small v-else-if="inputTask == 'api'">
                            <p class="subtitle is-7 is-uppercase">Upload data from API</p>
                        </small>
                        <small v-else>
                            <p class="subtitle is-7 is-uppercase">Upload data from file</p>
                        </small>
                    </h2>
                    
                    <div class="columns">
                        <div class="column is-10 is-offset-1">
                            <div class="columns">
                        
                        <div class="column is-12" v-if="inputTask == 'library'">
                            <div class="box" v-if="importDataCompleted">
                                <h4 class="title is-4"><i class="fa fa-check" aria-hidden="true"></i> Dataset metatext/{{ selectedDataset }} uploaded!</h4>
                            </div>
                            <div class="box" v-else>
                                <h4 class="title is-4">Select from Library</h4>
                                    <p class="subtitle is-6">Select a dataset from the library to get started.</p>
                                    
                                    <div v-for="dataset in datasetsLibrary" :key="dataset.id">
                                        <b-radio v-model="selectedDataset" class="" :label="dataset.name" :native-value="dataset.id" >
                                            <b>metatext/{{ dataset.id }}</b><br>
                                            {{ dataset.name }}<br>
                                            <small>{{ dataset.description }}</small>
                                        </b-radio>
                                        <hr style="max-height: 1px;">
                                    </div>
                                    
                                    <b-button type="is-info" @click="createDatasetFromLibrary" :disabled="isLoading || importDataCompleted" expanded>Select</b-button>
                                    <br><br><br>
                                
                            </div>
                        </div>
                        <div class="column is-12" v-else>
                            
                            <Uploads @datasetId="getDatasetId" @isComplete="getImportStatus" @labels="getLabels" :isOnboarding="true" :project="{id: projectId, type: modelType}" :currentUser="currentUser" :projectDocuments="[]" :inputTask="inputTask"/>
                            
                        </div>

                        </div>
                    </div>
                        
                    </div>
                </b-step-item>
                
               

                <b-step-item step="3" :label="setupStep>=3?'labels':''" v-if="modelType == 'classification' && setupStep > 1">
                    <div class="columns">
                        <div class="column is-half is-offset-one-quarter">
                            <div class="columns">
                        
                                <div class="column is-8 is-offset-2">

                                    <span v-if="availableTasks.includes(modelType) && modelType == 'classification'">
                                        <h2 class="subtitle is-4 has-text-centered">
                                            <small>
                                                <p class="subtitle is-7 is-uppercase">TRAINING</p>
                                                What Labels Do You Want To Classify?
                                            </small>
                                        </h2>
                                        

                                        <b-field label="Add label names (press Enter to add)" message="Add at least one label for binary classification. You can change it in the next steps.">
                                            <b-taginput
                                                size="is-medium"
                                                type="is-info"
                                                expanded
                                                :autocomplete="true"
                                                :data="project.label_suggestions"
                                                v-model="labels"
                                                :allow-new="true"
                                                :open-on-focus="true"
                                                placeholder="➕ Add a label">
                                            </b-taginput>
                                            
                                        </b-field>
                                        
                                    </span>
                                    <span v-else>
                                        <br><br>
                                        <h2 class="subtitle is-4 has-text-centered">
                                            💳 Subscribe to <b-tag size="is-small" type="is-dark">PRO</b-tag> plan for {{ engines[modelType].title }}
                                        </h2>
                                        
                                        <h2 class="subtitle is-5">
                                            Subscribe to activate the {{ engines[modelType].title }} engine for your account.
                                        </h2>
                                        <br>
                                        <p class="has-text-centered">
                                            Let us know if you need some help. Ask via chat or e-mail help@metatext.io
                                        </p>
                                        <br><br><br>
                                        
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-step-item>

                <b-step-item step="4" :label="setupStep>=3?'setup':''">
                        
                        <h2 class="subtitle is-4 has-text-centered">
                            <small>
                                <p class="subtitle is-7 is-uppercase">SETUP</p>
                                Name Your Model
                            </small>
                        </h2>
                        <div class="columns">
                        <div class="column is-half is-offset-one-quarter">
                            <div class="columns">
                        
                                <div class="column is-8 is-offset-2">

                        <b-field label="Name">
                            <b-input
                                type="text"
                                size="is-medium"
                                v-model="projectName"
                                placeholder="A notable name"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Language">
                            <b-select v-model="projectLanguage" size="is-medium" name="language" required expanded  placeholder="Choose a language">
                                <option value='Multilingual' selected>Multilingual</option>
                                <option v-for="l in ['English', 'Mandarin / Chinese', 'Hindi', 'Spanish', 'Portuguese', 'French', 'Arabic', 'Other - Multilingual']" :value="l">{{ l }}</option>
                            </b-select>
                        </b-field>
                        
                        <b-field label="Model base" message="Medium, Large and LLMs are available on PRO plan">
                            <b-select v-model="baseModel" size="is-medium" placeholder="Select a model base" expanded>
                                <optgroup label="Choose for me">
                                    <option value="automatic">Small</option>
                                    <option value="automatic-md" disabled>Medium</option>
                                    <option value="automatic-lg" disabled>Large</option>
                                </optgroup>
                                <optgroup label="Use LLM (Large Language Model)">
                                    <option value="chatgpt" :disabled="modelType != 'answering'">OpenAI GPT-3.5-turbo (ChatGPT)</option>
                                    <option value="gpt3" disabled>OpenAI GPT3 ada</option>
                                    <option value="bert" disabled>BERT</option>
                                    <option value="setfit" disabled>SetFit</option>
                                </optgroup>
                            </b-select>
                            
                        </b-field>
                        <span v-if="modelType == 'answering'">
                        <b-tag  type="is-dark">Available</b-tag> ChatGPT (OpenAI GPT-3.5-turbo) available for answering questions.
                        </span>
                        
                        
                    </div></div></div></div>
                    
                </b-step-item>

                <b-step-item step="" :label="setupStep>=4?'':''">
                        
                        <h2 v-if="isLoading" class="subtitle is-4 has-text-centered">
                            <small>
                                <p class="subtitle is-7 is-uppercase">SETUP</p>
                                    Creating your project AI...
                            </small>
                        </h2>
                        <h2 v-else class="subtitle is-4 has-text-centered">
                            <small>
                                <p class="subtitle is-7 is-uppercase">SETUP</p>
                                    Congratulations!
                            </small>
                        </h2>
                        <div class="columns">
                        <div class="column is-half is-offset-one-quarter">
                            <div class="columns">
                        
                                <div class="column is-4 is-offset-4">
                                    
                                    <div class="boards-grid setup-center" v-if="projectId">

                                        <a @click="redirect" class="card board">
                                        
                                        <div class="card-content info" type="is-info">
                                            <div class="content">
                                            <div class="media-content">
                                                
                                                <p class="name title is-5">
                                                {{project.name}}
                                                </p>
                                                <p class="description is-6">
                                                <span v-if="project.description != undefined">
                                                    {{ project.description }}
                                                </span>
                                                <span v-else>
                                                    &nbsp;
                                                </span>
                                                </p>
                                            </div>
                                            </div>
                                            <div class="bottom">
                                                
                                                <b-tag type="is-info">
                                                {{ project.annotationMode?'annotation':'training' }}
                                                </b-tag>
                                                <b-tag type="is-secondary" class="is-pulled-right">
                                                {{ project.type }}
                                                </b-tag>
                                            </div>

                                            </div>
                                        </a>

                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                </b-step-item>
                
                <template
                #navigation="{previous, next}">
                    <div class="footer">
                        
                    <b-field>
                        <b-button
                            expanded
                            type="is-light"
                            size="is-medium"
                            icon-pack="fas"
                            icon-left="angle-left"
                            :disabled="previous.disabled"
                            @click.prevent="previous.action">
                            Previous
                        </b-button>
                        <b-button
                            tag="router-link"
                            size="is-medium"
                            expanded
                            v-if="setupStep == 0 && !availableTasks.includes(modelType) || setupStep > 0 && !availableInputTask.includes(inputTask)"
                            class="" 
                            :to="`/account/checkout`">
                            Book a demo 
                            <!-- <b-tag size="is-small" type="is-dark">Enterprise</b-tag> -->
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 1"
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled"
                            @click="createProjectDraft"
                            @click.prevent="next.action">
                            Continue
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 2"
                            expanded
                            type="is-info"
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled || (!importDataCompleted && inputTask != 'api')"
                            @click="createProjectDraft"
                            @click.prevent="next.action">
                            Continue
                        </b-button>
                        
                        <b-button
                            v-else-if="(setupStep == 4 || (setupStep == 3 && modelType != 'classification'))  && availableTasks.includes(modelType)"
                            tag="button"
                            @click="createProject"
                            size="is-medium"
                            label="Finish"
                            type="is-info"
                            expanded 
                            :disabled="!availableTasks.includes(modelType)"/>
                        <b-button
                            v-else-if="setupStep == 5 && availableTasks.includes(modelType)"
                            tag="button"
                            @click="redirect"
                            size="is-medium"
                            label="Finish"
                            type="is-info"
                            expanded 
                            :disabled="!availableTasks.includes(modelType)"/>
                        <b-button
                            v-else
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            
                            :disabled="next.disabled"
                            @click.prevent="next.action">
                            Next step
                        </b-button>
                    </b-field>
                    
                    </div>
                </template>
                
            </b-steps>
            

        </section>
    </form>
    </template>
    <script>
    

import Uploads from "@/dashboard/Project/Uploads.vue";

export default {
      props: {
        stepId: String
      },
      data() {
        
        return {
            projectId: null,
            importDataCompleted: false,
            projectCreated: false,
            setupStep: 0,
            labels: [],
            adding_label: undefined,
            readyToCreate: false,
            isLoading: false,
            projectName: null,
            projectLanguage: 'Multilingual',
            projectDescription: false,
            settings: {
                readOnly: true,
                rowHeaders: true,
                licenseKey: 'non-commercial-and-evaluation'
            },
            inputTaskList: [{id: 'library', name: 'From Our Library'}, {id: 'csv', name: 'From CSV'}, {id: 'pdf', name: 'From any DOC'}, {id: 'api', name: 'From REST API'}],
            inputTask: 'library',
            availableInputTask: ['csv', 'pdf', 'html', 'library', 'api'],
            baseModel: 'automatic',
            modelType: 'classification',
            modelTypeList: [
                {id: 'classification', name: 'Classification', step: 'train'},
                {id: 'generation', name: 'Generation', step: 'finetune'},
                {id: 'extraction', name: 'Extraction', step: 'finetune'}
            ],
            availableTasks: ['classification', 'answering', 'generation'],
            modelTask: 'topic',
            modelTaskList:[
                {id: 'topic', name: 'Topic classification'}, 
                {id: 'sentiment', name: 'Sentiment Analysis'}, 
                {id: 'intent', name: 'Intent Classification'},
                {id: 'other', name: 'Other Classification'}
            ],
            datasetsLibrary: [
                {id: 'ag_news', name: 'Topic classification', description: "News articles from 4 categories: World, Sports, Business, Sci/Tech"},
                {id: 'banking77', name: 'Intent recognition', description: "Banking support tickets from 12 categories"},
                {id: 'sst2', name: 'Sentiment analysis', description: "Movie reviews from 2 categories: positive, negative"},
            ],
            sampleDataframe: false,
            datasetName: '',
            isFinished: false,
            selectedDataset: 'ag_news',
            csv: null,
            label_col: false,
            text_col: false,
            animated: true,
            imageData: null,
            file2: false,
            picture: null,
            files: [],
            uploadValue: 0,
            csv: 1,
            json: 1,
            previewDataset: null,
            isComponentModalActive: false,
            isComponentDatasetEditActive: false,
            selectedTask: null,
            tasks: [
                {'task': 'Text Classification (Binary)'},
                {'task': 'Text Classification (Multiclass)'},
                {'task': 'Text Classification (Multilabel)'},
            ],
            columns: [
                {
                    field: 'task',
                }
            ],
            engines: {
                "classification": 
                {
                    "title": "Text Classification", 
                    "description": "Build a text classification model to categorize texts using given output labels (categories) you provide."
                },
                "extraction": {
                    "title": "Text Extraction",
                    "description": "Build a text extraction model to identify parts of text with entities using given entities examples you provide."
                },
                "generation": {
                    "title": "Text Generation",
                    "description": "Build a generation model to generate texts based using given generated examples your provide."
                }
            }
        };
      },
      components: {
        Uploads
      },
      created() {
        this.$store.dispatch("currentUser");
      },
      computed: {
        project() {
            return this.$store.state.project;
        },
        currentUser() {
          return this.$store.state.currentUser;
        },
        plans() {
            return this.$store.state.plans
        },
        datasets() {
            return this.$store.state.datasets //publicDatasets
        }
      },
      mounted(){
        let stepId = this.$route.params.stepId
        
        this.modelType = (stepId?stepId:'classification')
        console.log(stepId, this.modelType)
        this.$store.dispatch("retrieveAllDatasets", this.projectId);
      },
      watch: {
        // whenever question changes, this function will run
        projectId() {
            if (this.projectId != null) {
                this.$store.dispatch("currentProject", this.projectId);
            }
        },
        project(){
            this.getLabels()
        }
      },
      methods:{
        createDatasetFromLibrary(){
            let datasetLibraryName = this.selectedDataset
            const dataset = {
                    projectId: this.projectId
            }
            console.log(dataset)
            
            var newDataset = this.$store.dispatch("createDataset",
                dataset
            )

            newDataset.then(datasetId => {
                
                const addDatasetToProject = {
                        projectId: this.projectId,
                        update: {
                            datasetId: datasetId,
                        }
                }

                console.log(addDatasetToProject)
                
                this.$store.dispatch("addDatasetToProject",
                    addDatasetToProject
                )

                this.project.datasetId = datasetId
                this.datasetId = datasetId

                const datasetUpload = {
                    datasetId: datasetId,
                    projectId: this.projectId,
                    datasetLibraryName: datasetLibraryName,
                    filename: `metatext/${datasetLibraryName}`,
                }

                console.log(datasetUpload)

                var newUpload = this.$store.dispatch("increaseDataset",
                    datasetUpload
                )

                newUpload.then(uploadId => {
                    this.isLoading = true
                    this.$store.dispatch("datasetAnalysis",{datasetId: datasetId, uploadId: uploadId}).then( (res) => {
                        let status = res.status
                        let records = res.records
                        this.$buefy.dialog.confirm({
                                message: `${status}. ${records} records added\n\n`,
                                canCancel: false,
                                onConfirm: () => {
                                    this.isLoading = false
                                    if (status == "completed"){
                                        this.getImportStatus(true)
                                    } else {
                                        this.getImportStatus(false)
                                    }
                                
                                    
                                }
                        })
                    })
                })
                
            }, (error) => {
                console.log(error)
            })
        },
        getImportStatus(isCompleted){
            this.importDataCompleted = isCompleted
        },
        getDatasetId(datasetId){
            this.datasetId = datasetId
        },
        title(){
            try {
                return this.engines[this.radioButton].title
            } catch {
                return false
            }
            
        },
        description(){
            try {
                return this.engines[this.radioButton].description
            } catch {
                return false
            }
        },
        stepCheck(){
            if (this.setupStep == 1){
                this.createProjectDraft()
            } else if (this.projectId != null){
                this.$store.dispatch("currentProject", this.projectId);
            }
        },
        setupCurrentStep(){
            let step = this.setupStep
            // classification, 0, 1, 2, 3, 4
            // classification, 0, 1, 2, 3, 4

        },
        getLabels(labels = null){
            if (this.project && "labels" in this.project){
                this.project.labels.forEach( (item) => {
                    if (!this.labels.includes(item.label)){
                        this.labels.push(item.label)
                    }
                })
            }

            if (labels){
                labels.forEach( (i) => {
                    this.labels.push(i)
                })
            }
            

        },
        createProjectDraft(){

            if (this.projectId != null){
                this.$store.dispatch("currentProject", this.projectId);
                this.getLabels()
                return;
            }
            
            const project = {
                name: "Untitled",
                type: this.modelType,
                description: "draft project",
                baseModel: this.baseModel,
                userId: this.currentUser.organizationId ? this.currentUser.organizationId : this.currentUser.id
            }
    
            var newDoc = this.$store.dispatch("createProject",
                project
            )
    
            newDoc.then(projectId => {
                this.projectId = projectId
            })

            this.$store.dispatch("currentProject", this.projectId);

        },
        createProject(){
            // Ask for at least one label
            if(this.modelType === 'classification' && this.labels.length < 1){
                this.$buefy.dialog.alert({
                    message: '<b>Must provide at least one label to your project.</b><br><br><b>For example, for spam detection:</b><br>You can provide the output labels (categories) spam and not spam. The model will learn how to categorize the texts into this labels.<br><br>If you already have a dataset annotated with labels, please add the first one label, then in the next step you will upload your CSV file and all the labels will be loaded automatically.',
                });
                return;
            }

            // Set loading spinning
            this.isLoading = true
            
            // Fix labels
            let projectLabels = []
            if(this.modelType === 'classification'){
                this.labels.forEach(function (label, i) {
                    projectLabels.push({label_code: i, label: label})
                });
                if (projectLabels.length == 1){
                    projectLabels.push({label_code: projectLabels[0].label_code, label: `not ${projectLabels[0].label}`})
                }
            }
            
            // Retrieve datasetId from project or Upload
            const datasetId = (this.project.datasetId?this.project.datasetId:this.datasetId)

            // Create a model
            const model = {
                projectId: this.projectId,
                type: this.modelType,
                trigger: true,
                base: this.baseModel,
                datasetId: datasetId
            }

            var newDoc = this.$store.dispatch("createModel",
                model
            );

            newDoc.then(newModelId => {
                
                const addModelToProject = {
                  projectId: this.project.id,
                  add: {
                    models: [newModelId],
                    modelId: newModelId,
                  }
                }
                this.$store.dispatch("addModelToProject",
                  addModelToProject
                );
            })

            // Create a project
            const projectToUpdate = {
                projectId: this.projectId,
                update: {
                    name: (this.projectName)?this.projectName:"Untitled",
                    type: this.modelType,
                    labels: projectLabels,
                    language: this.projectLanguage,
                    inputTask: this.inputTask,
                    baseModel: this.baseModel
                }
            }

            var newProjectDoc = this.$store.dispatch("updateProject",
                projectToUpdate
            )

            // Go though the final step onboarding
            newProjectDoc.then(() => {
                this.projectCreated = true
                this.setupStep = 5
            })

            this.isLoading = true
            
            setTimeout(() => {
                this.isLoading = false
            },  2*1000)
            
        },
        creditsNeeded(){
            let dot = 1//this.modelSizePrice[this.modelSize]
            return parseInt(this.rowsLength * dot)
        },
        enoughCredits(){
            let credits = this.currentUser.creditsRemaining
            let records = this.creditsNeeded()
            return credits >= records
        },
        availableCredits(){
            let credits = this.currentUser.creditsRemaining
            return credits | 0
        },
        completeConfirm(){
            this.isLoading = false
            this.setupStep = 5
            // let content = `<b>Creating the ${this.projectName} project.</b><br><br>Now it's up to you, here is what you need to do in the next steps:<br><br>1. <b>Data labeling</b> your input data to teach your AI model how to classify.<br><br>2. <b>AI Text Classifier</b> will continuously training in background when you annotate.<br><br>3. Check the AI model training and call your AI model using <b>API</b><br><br>We're here to help you have a success journey with AI. Ask on the chat support 😃💬`
            // this.$buefy.dialog.confirm({
            //             message: content,
            //             canCancel: false,
            //             onConfirm: () => this.redirect(this.projectId) 
            // })
        },
        openLoading() {
                let isFullPage = true
                const loadingComponent = this.$buefy.loading.open({
                    container: isFullPage ? null : this.$refs.element.$el
                })
                setTimeout(() => loadingComponent.close(),  3*1000)
        },
        redirect(){
            let project_name = (this.projectName)?this.projectName:"Untitled"
            this.$buefy.toast.open(`Opening the project ${project_name}...`)
            
            let step = this.modelTypeList.filter( i => i.id == this.modelType)[0]['step']

            this.isLoading = true
            setTimeout(() => {
                this.$router.push(`/projects/${this.projectId}/${step}`)
            },  4)
            
        },
      }
        
    }
    </script>
    <style lang="scss" scoped>
.footer {
    position: fixed;
    height: 50px;
    bottom: -30px;
    left: 0px;
    right: 0px;
    margin-bottom: 0px;
}



.setup-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 2fr));
    gap: 3em;
  
    .setup-selected {
          border: dashed 3px #bdbdbd !important;
      }
  
    .setup {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      
  
      &:hover {
        background: #fafafa;
        border: dashed 1px #bdbdbd;
      }
  
      &:active {
          border: dashed 2px #bdbdbd;
      }
  
      &:checked {
          border: dashed 2px #bdbdbd;
      }
      
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }
  
  .setup-center {
    margin: auto;
    width: 90%;
  }




  .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
    gap: 16px;
  
    .board-create {
      cursor: pointer;
      border: dashed 4px #e6e4e4;
      border-radius: 0px;
      min-width: 40em;
      min-height: 10em;
    
      &:hover {
        border: dashed 4px #bdbdbd;
      }
    }
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 10em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
  }
</style>